import './Footer.css';
import Icon from './Icon';
import { SESSIONS } from '../data/sessions';

// §5.13 nav links lifted verbatim: About · Programs · Approach · Why us · For colleges · Contact
// The Sessions link is a real route (/sessions), shown only once photos exist. On subpages,
// in-page anchors are prefixed with "/" so they navigate home first, then scroll.
const onHome = typeof window !== 'undefined' && window.location.pathname === '/';
const toHref = (anchor) => (onHome ? anchor : `/${anchor}`);
const QUICK_LINKS = [
  { label: 'About Founder', href: toHref('#about') },
  { label: 'Programs',     href: toHref('#programs') },
  { label: 'Approach',     href: toHref('#approach') },
  { label: 'Why us',       href: toHref('#why-us') },
  ...(SESSIONS.length > 0 ? [{ label: 'Programs we offer', href: '/sessions' }] : []),
  { label: 'Contact Us',   href: toHref('#contact') },
];

// Only the Privacy page exists as a real route; Terms/Cookie pages are intentionally
// omitted to avoid dead links (unknown paths fall through to the landing page).
const LEGAL_LINKS = [
  { label: 'Privacy Policy', href: '/privacy-policy' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__col footer__brand">
          <img
            src="/assets/logo.png"
            alt="WAYFWD Strategies"
            className="footer__logo"
            width="44"
            height="44"
          />
          <div className="footer__wordmark">WAYFWD Strategies</div>
          <div className="footer__tag">Communication • Leadership • Workplace Excellence • Emotional Intelligence Coach</div>
        </div>

        <div className="footer__col">
          <div className="eyebrow footer__label">NAVIGATE</div>
          <ul className="footer__list">
            {QUICK_LINKS.map((l) => (
              <li key={l.href}><a href={l.href} className="footer__link">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <div className="eyebrow footer__label">LEGAL</div>
          <ul className="footer__list">
            {LEGAL_LINKS.map((l) => (
              <li key={l.href}><a href={l.href} className="footer__link">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div className="footer__col">
          <div className="eyebrow footer__label">CONTACT US</div>
          <ul className="footer__list">
            <li><a href="tel:+919152128293" className="footer__link">+91 9152128293</a></li>
            <li><a href="mailto:anjum@wayfwdstrategies.com" className="footer__link">anjum@wayfwdstrategies.com</a></li>
            <li><span className="footer__link footer__link--static">Mumbai, India</span></li>
          </ul>
          <div className="footer__socials">
            <a
              href="https://www.linkedin.com/in/anjum-qazi-542950268/"
              className="footer__social"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WAYFWD Strategies on LinkedIn"
            >
              <Icon name="linkedin" size={20} />
            </a>
            <a
              href="https://www.instagram.com/wayfwdstrategies/"
              className="footer__social"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WAYFWD Strategies on Instagram"
            >
              <Icon name="instagram" size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container">© 2026 WAYFWD Strategies. All rights reserved.</div>
      </div>
    </footer>
  );
}
